/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9Ikljb25fZnVsbHNjcmVlbiIgZGF0YS1uYW1lPSJJY29uL2Z1bGxzY3JlZW4iPjxwYXRoIGlkPSJDb21iaW5lZC1TaGFwZSIgZD0iTTIuMzgsMTR2Ny42MUgxMFYyM0gxVjE0Wk0yMywxNHY5SDE0VjIxLjYxaDcuNjJWMTRaTTEwLDFWMi4zOEgyLjM4VjEwSDFWMVpNMjMsMXY5SDIxLjYxVjIuMzhIMTRWMVoiLz48L2c+PC9zdmc+";